import { proxy } from 'valtio'

export const priceDiffStore = proxy({
  max: NaN as number,
  min: NaN as number,
})
